import BaseModel from "../base/baseModel";

export default class ProdutoFornecedorModel extends BaseModel {
    id?: number = null;
    produtoId?: number = null;
    fornecedorId?: number = null;
    fornecedorDescricao?: string = null;
    ordem?: number = null;
}
